<template>
	<v-tab-item>
		<h3 class="text-h6 font-weight-bold">関連依頼</h3>
		<v-card flat>
			<div v-if="requirements.length">
				<RequirementUnit
					v-for="(requirement, i) in requirements"
					:key="i"
					:requirement="requirement"
				/>
			</div>
			<div v-else>
				<p class="text-body-2">関連依頼はありません。</p>
			</div>
		</v-card>
		<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
	</v-tab-item>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import RequirementUnit from "../../shared/RequirementUnit.vue"
import PaginationModule from "../../shared/PaginationModule.vue"

export default {
	props: {
		id: {
			type: Number || null,
		},
		// requirements: {
		// 	type: Array,
		// 	required: false,
		// 	default: () => [],
		// },
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		RequirementUnit,
		PaginationModule,
	},
	data() {
		return {
			requirements: [],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
		}
	},
	methods: {
		getPage(i) {
			this.fetchRequirements(i)
			const scrollArea = document.getElementById("scroll-area")
			scrollArea.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		fetchRequirements(page) {
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()
			axios
				.get(`/erp/v1/order_individual_infos/${this.id}/requirements`, {
					params: { page },
					headers,
				})
				.then((res) => {
					this.requirements = res.data.requirements
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
	watch: {
		isFetched(newVal, oldVal) {
			if (oldVal == false && newVal == true) {
				this.fetchRequirements()
			} else if (oldVal == true && newVal == false) {
			}
		},
	},
}
</script>